export interface CardBadgeProps {
  icon?: React.ReactElement;
  text: string;
}

function CardBadge(props: CardBadgeProps) {
  return (
    <div className="ct_cardBadge">
      {props.icon && (<div className="ct_cardBadge-icon">{props.icon}</div>)}
      {props.text && (<div className="ct_cardBadge-content">{props.text}</div>)}
    </div>
  );
}

CardBadge.defaultProps = { ...{} };

export default CardBadge;
